import React from 'react'
import { Grid, PageSection as Section } from '@superhi/design'
import Image from 'next/image'

import { Items, Item } from './styles'

const DATA = [
  'kickstarter',
  'aiga',
  'deliveroo',
  'nyt',
  'vox-media',
  'dandad',
  'asana',
  'boilerroom',
  'coinbase',
  'google',
  'figma',
  'genius',
]

const GRID_1_CELL_1_SPAN: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 'full',
  large: [3, 10],
}

const Companies: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Section
    title="The future’s bright"
    subtitle="We’re really proud to say that our students work at places like..."
    subtitleMaxWidth={36}
    collapseBottomPadding
    decorationName="triangle"
    decorationPosition="bottom-left"
    // collapseTopPadding
    headingLevel={2}
  >
    <Grid>
      <Grid.Cell span={GRID_1_CELL_1_SPAN}>
        <Items>
          {DATA.map((data) => (
            <Item key={data}>
              <Image src={`/images/biz-${data}.svg`} alt={data} width={136} height={50} />
            </Item>
          ))}
        </Items>
      </Grid.Cell>
    </Grid>
  </Section>
)

export default Companies
